export default __webpack_public_path__ + "static/media/info-forgot-password-in.93b8d07e.gif";